import { render } from "./ProductDetailsComponent.vue?vue&type=template&id=69a86178"
import script from "./ProductDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ProductDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/ProductDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69a86178"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69a86178', __exports__)) {
    api.reload('69a86178', __exports__)
  }
  
  module.hot.accept("./ProductDetailsComponent.vue?vue&type=template&id=69a86178", () => {
    api.rerender('69a86178', render)
  })

}


export default __exports__